import { gql } from "@apollo/client";

export const GetEcCardsQuery=gql`
query GetECCards($qr_code: String = "", $phone_number: String = "") {
  ec_cards(where: {qr_code: {_eq: $qr_code}}) {
    qr_code
    id
    user_id
  }
  ec_users(where: {phone_number: {_eq: $phone_number}}) {
    id
    name
    phone_number
  }
}
`